module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('a', {
    class: {
      button: true,
        'is-primary': !_vm.editing
    },
    on: {
      "click": function($event) {
        _vm.editing = !_vm.editing
      }
    }
  }, [_vm._v(_vm._s(_vm.editing ? 'Cancel Editing' : 'Edit Image'))]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.deleteImage()
      }
    }
  }, [_vm._v("\n                Delete Image\n            ")])]), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('div', [_c('strong', [_vm._v("Thumbnail")]), _vm._v("\n                    (" + _vm._s(_vm._f("prettyBytes")(_vm.image.thumbnail_size)) + " - " + _vm._s(_vm.image.thumbnail_width) + "x" + _vm._s(_vm.image.thumbnail_height) + "px)\n                    "), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.image.thumbnail_path
    }
  })]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Normal Size")]), _vm._v("\n                    (" + _vm._s(_vm._f("prettyBytes")(_vm.image.normal_size)) + " - " + _vm._s(_vm.image.normal_width) + "x" + _vm._s(_vm.image.normal_height) + "px)\n                    "), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.image.normal_path
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Content linked to this image")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Products")]), _vm._v(" "), _vm._l((_vm.linkedProducts), function(product) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: product.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(product.name) + "\n                        ")])], 1)
  }), _vm._v(" "), (_vm.linkedProducts.length === 0) ? _c('div', [_vm._v("\n                        No products linked to this image\n                    ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Bundles")]), _vm._v(" "), _vm._l((_vm.linkedBundles), function(bundle) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'bundle',
          params: {
            id: bundle.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(bundle.name) + "\n                        ")])], 1)
  }), _vm._v(" "), (_vm.linkedBundles.length === 0) ? _c('div', [_vm._v("\n                        No bundles linked to this image\n                    ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Items")]), _vm._v(" "), _vm._l((_vm.linkedItems), function(item) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'item',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                        ")])], 1)
  }), _vm._v(" "), (_vm.linkedItems.length === 0) ? _c('div', [_vm._v("\n                        No items linked to this image\n                    ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Pages")]), _vm._v(" "), _vm._l((_vm.linkedPages), function(page) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'page',
          params: {
            id: page.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(page.name) + "\n                        ")])], 1)
  }), _vm._v(" "), (_vm.linkedPages.length === 0) ? _c('div', [_vm._v("\n                        No pages linked to this image\n                    ")]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('div', [(_vm.image.full_path) ? _c('strong', [_vm._v("Full Size (possibly scaled)")]) : _c('strong', [_vm._v("Full Size Version Not Available")]), _vm._v(" "), (_vm.image.full_path) ? _c('span', [_vm._v("\n                (" + _vm._s(_vm._f("prettyBytes")(_vm.image.full_size)) + " - " + _vm._s(_vm.image.full_width) + "x" + _vm._s(_vm.image.full_height) + "px)\n                "), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.image.full_path
    }
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.editing) ? _c('div', [_c('br'), _vm._v(" "), _c('image-form', {
    attrs: {
      "image": _vm.image
    },
    on: {
      "saved": function($event) {
        _vm.editing = false
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f24a111"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/images/ImageEdit.vue
// module id = 509
// module chunks = 0